module.exports = __webpack_public_path__ + "ecs.icon.83b41.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/ecs/logo/ecs.icon.svg
// module id = 3951
// module chunks = 0